import React from 'react';
import { InputAdornment, InputBase, MenuItem, Select } from '@material-ui/core';
import { FieldProps, FormikProps } from 'formik';
import { Counter, CounterProps } from '../../../ui-kit';
import { MenuListProps } from '../../../constants';
import { Options } from './types';
import Field from './Field';

export interface CounterWithSelectFieldProps<T> extends Omit<CounterProps, 'onChange' | 'name'>{
    selectProps: SelectCounterFieldProps;
    inputProps: InputCounterFieldProps;
    handleChange?: (e: React.ChangeEvent<any>) => void;
    formikProps: FormikProps<T>;
}

export interface InputCounterFieldProps {
    name: string;
    initialValue?: number | null;
    placeholder: string;
    isTextHighlighted?: boolean;
    isDanger?: boolean;
}

export interface SelectCounterFieldProps {
    options: Array<Options>;
    defaultValue?: string;
    name: string;
}

const InputAdormentSelect = ({ options, defaultValue, ...other }: SelectCounterFieldProps & FieldProps<Options>['field']) => {
    return (
        <InputAdornment position="end">
            <Select {...other} input={<InputBase />} MenuProps={MenuListProps} defaultValue={defaultValue} disabled={options.length === 1}>
                {options.map((option = { id: '', name: '' }) => (
                    <MenuItem key={option.id || ''} value={option.id || ''}>
                        {option.name.slice(0, 3) || ''}
                    </MenuItem>
                ))}
            </Select>
        </InputAdornment>
    );
};

const CounterFieldWithSelect = <T, >({
    inputProps,
    selectProps,
    handleChange,
    formikProps: {
        handleChange: formikHandleChange,
        ...otherFormikProps
    },
    ...other
}: CounterWithSelectFieldProps<T>) => {
    const onChange = (e: React.ChangeEvent<any>) => {
        formikHandleChange(e);
        if (handleChange) {
            handleChange(e);
        }
    };

    const finalFormikProps = {
        ...otherFormikProps,
        handleChange: onChange
    };


    return (
        <Field
            {...other}
            {...inputProps}
            renderer={Counter}
            formikProps={finalFormikProps}
            endAdornment={(
                <Field
                    {...selectProps}
                    renderer={InputAdormentSelect as any}
                    formikProps={finalFormikProps}
                />
                )}
        >
        </Field>
    );
};

export default CounterFieldWithSelect;
